import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { BottomSheetContext } from '../../provider/BottomSheetProvider'

import { Color } from '../../theme/color'

/**
 ** children: any - Bottom Sheet 안에 들어갈 내용
 ** backdrop?: boolean - Bottom Sheet 뒤에 backdrop 유무
 ** $height?: string - Bottom Sheet 높이
 */
interface BottomSheetProps {
  children: any
  backdrop?: boolean
  $height?: string
}

// transition timer
const TIMER = 200

export function BottomSheet({ children, $height, backdrop = true }: BottomSheetProps) {
  const { hideBottomSheet } = useContext(BottomSheetContext)

  const [show, setShow] = useState(false)

  const hide = () => {
    setShow(false)
    hideBottomSheet()
  }

  useEffect(() => {
    setShow(true)
    return () => {
      setShow(false)
      hideBottomSheet()
    }
  }, [])

  return (
    <Wrap>
      {backdrop && <Backdrop show={show} onClick={hide} />}
      <Container show={show} $height={$height}>
        <Content>{children}</Content>
      </Container>
    </Wrap>
  )
}

function Render() {
  const { bottomSheet } = useContext(BottomSheetContext)
  if (!bottomSheet) return null
  const { Component, props } = bottomSheet
  return <Component {...props} />
}

BottomSheet.Render = Render

const Wrap = styled.div`
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20000;
  width: 100%;
  height: 100%;
`

const Backdrop = styled.div<{ show: boolean }>`
  opacity: ${({ show }) => (show ? 1 : 0)};
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-color: rgba(28, 34, 39, 0.6);
  transition: ${TIMER / 1000}s;
`

const Container = styled.div<Pick<BottomSheetProps, '$height'> & { show: boolean }>`
  position: relative;
  bottom: ${({ show }) => (show ? 0 : '-100%')};
  width: 100%;
  max-height: ${({ $height }) => $height ?? 'auto'};
  margin-bottom: ${({ show }) => (show ? 0 : '-100%')};
  padding-bottom: env(safe-area-inset-bottom);

  transition: ${TIMER / 1000}s;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  background-color: ${Color.white};
`
